import { render } from "./LogoHSC2.vue?vue&type=template&id=ee4126cc"
import script from "./LogoHSC2.vue?vue&type=script&lang=js"
export * from "./LogoHSC2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__